export default "__VITE_ASSET__4990d50d__"